// Slider
// Prevent click event when dragging
var drag = false;

// Allow more than one slider at the same time
document.querySelectorAll('.mens-collection-list__slider').forEach(slider => { 
  new KeenSlider(slider, {
    dragChecked() {
      drag = true;
    },
    dragEnded() {
      setTimeout(() => (drag = false), 0);
    },
    created() {
      document.querySelectorAll('.mens-collection-list__slider').forEach(slider => {
        slider.addEventListener("click", (e) => {
          if (drag) {
            e.stopPropagation();
            e.preventDefault();
          }
        })
      });
    },
    breakpoints: {
      '(max-width: 749px)': {
        slides: {
          perView: 2.5,
          spacing: 16
        }
      },
      '(min-width: 750px)': {
        slides: {
          perView: 3.5,
          spacing: 20
        }
      },
      '(min-width: 990px)': {
        disabled: true,
      },
    },
  }, [navigation])
})